import React from "react";
import styles from "./Schnellzugriff.module.css";

import { SlCalender } from "react-icons/sl";
import { BsChatRightText } from "react-icons/bs";
import { VscAccount } from "react-icons/vsc";
import { HiOutlineDocumentArrowDown } from "react-icons/hi2";


const links = [
  {
    title: "Schuljahr",
    subtitle: "Termine & Ferien",
    url: "https://start.schulportal.hessen.de/kalender.php?i=4393",
    icon: <SlCalender />
  },
  {
    title: "Downloads",
    subtitle: "Formulare & Dokumente",
    url: "/downloads",
    icon: <HiOutlineDocumentArrowDown />
  },
  {
    title: "Organisation",
    subtitle: "Struktur & Gremien",
    url: "/organisation",
    icon: <VscAccount />
  },
  {
    title: "Kontakt",
    subtitle: "Wir sind für Sie da",
    url: "/kontakt",
    icon: <BsChatRightText />
  }
];


export default function Schnellzugriff() {

  return (
    <div className={styles.container}>

      {links.map((link,index)=>(

        <button
          key={index}
          className={styles.item}
          onClick={()=> window.location.href = link.url}
        >

          <div className={styles.icon}>
            {link.icon}
          </div>


          <div className={styles.text}>

            <div className={styles.title}>
              {link.title}
            </div>

            <div className={styles.subtitle}>
              {link.subtitle}
            </div>

          </div>

        </button>

      ))}

    </div>
  );
}